/* istanbul ignore file */
import React from 'react'
import ReactDOM from 'react-dom'
import { StoreProvider } from 'easy-peasy'

import App from './components/AppFantasia'
import store from 'store'
import 'utils/rollbar'

if (globalThis.Cypress) {
  globalThis.getTrackedEvents = () => store.getState().tracking.trackedEvents
}

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('mortgage-rate-table-app')
)
